import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import FormButtonGroup from '../components/layout/FormButtonGroup.jsx';

export default function TransitionScreen({ onContinue, onSkip, onBack }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '20px',
        textAlign: 'center',
        maxWidth: '600px',
      }}
    >
      <Typography variant="h1" gutterBottom sx={{ fontSize: '2rem!important' }}>
        Thank You!
      </Typography>

      <Typography variant="body1" paragraph>
        You have successfully completed the required information section.
      </Typography>

      <Typography variant="body1" paragraph>
        We have a few optional questions that would greatly assist us in understanding your journey
        better. Answering these will help improve our alumni services.
      </Typography>

      <Box sx={{ marginTop: '30px' }}>
        <FormButtonGroup>
          {/* Back Button - secondary action */}
          <Button variant="contained" size="large" color="error" onClick={() => onBack()}>
            Back
          </Button>
          {/* Skip Button - secondary action */}
          <Button
            variant="outlined"
            size="large"
            color="primary"
            onClick={onSkip}
            sx={{ marginRight: '10px' }}
          >
            Skip to Finish
          </Button>

          {/* Continue Button - primary action */}
          <Button variant="contained" size="large" color="primary" onClick={() => onContinue()}>
            Continue
          </Button>
        </FormButtonGroup>
      </Box>
    </Box>
  );
}

TransitionScreen.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};
